<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:50:27
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-13 14:14:07
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/component-lndn.vue
 * @Description: 联农带农
-->
<template>
  <div class="lndn">
    <div class="content">
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.lndn {
  padding-top: 52px;
  .content {
    height: 100%;
    position: relative;
    padding: 1px 7px;
    background-image: url('/public/image/company-profile/bg/联农带农.gif');
  }
}
</style>
